import React, {useEffect} from "react";

const GenericItem = ({title, details, cssClasses, testid = 'genericItem'}) => {
    return (
        <div className={`plan-item flexColumn margin-top-1 ${cssClasses}`} data-testid={testid}>
            <div className={'plan-sub-title'}>
                {title}
            </div>
            <div className={'plan-sub-details'}>
                {details}
            </div>
        </div>
    );
}

export default GenericItem;